/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, string, shape, bool, arrayOf, func,
} from 'prop-types';
import qs from 'qs';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';
import ReactHTMLParser from 'react-html-parser';
import Media from 'react-media';
import { withStyles } from '@material-ui/core/styles';
import Slider from 'react-slick';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Fade } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { actions as tagManagerActions } from '../../../../../../../state/ducks/TagManager';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import isProductListingAd from '../../../../../../helpers/isProductListingAd';
import SmartGift from '../../SmartGift/SmartGift';
import { shouldRenderSnipe, snipePath, isSnipeImageActive } from '../../common/commonProductPageHelper';
import GraphqlClubPDPImage from '../../GraphqlClubPDPImage/GraphqlClubPDPImage';
import { clubComponentType } from '../../common/types';
import SnipeRender from '../../common/SnipeRender';
import SnipeRenderQuery from '../../common/SnipeRenderQuery';
import ResponsiveImage from '../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getPmallSummaryInfo } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { pmallPluginConfig } from '../../../../../../../state/ducks/Common/ducks/PmallPersonalization/PmallPersonalization-Helper';
import SmartGiftContainer from '../../SmartGiftContainer';
import CarouselAltImg from '../CarouselAltImg';
import VideoComponent from '../VideoComponent';
import ProductImageZoomingUI from './ProductImageZoomingUI';
import { getFeatureFlag } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import FavoritesUI from '../../../../GraphqlCommonComponents/Favourite/FavouriteUi';

const { sdkURL } = pmallPluginConfig;
const styles = (theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        background: theme?.palette?.white,
        [theme?.breakpoints?.down('md')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },
    altImageContainer: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme?.breakpoints?.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
        },
    },
    plaAltImages: {
        maxWidth: '75px',
    },
    altImageButton: {
        display: 'block',
        padding: 0,
        margin: '0 10px 10px 0',
        position: 'relative',
        width: '100%',
        height: 'auto',
        cursor: 'pointer',
        '& img': {
            display: 'block',
        },
        [theme?.breakpoints?.down('md')]: {
            maxWidth: '110px',
            width: '100%',
        },
        '&:focus': { // fixed accessibility issue
            outline: 'auto',
        },
        '&:not(:focus):not(:focus-visible)': {
            border: 'none',
            outline: 'none',
        },
    },
    altImage: {
        width: '100%',
        height: 'auto',
        maxHeight: '124px',
    },
    altImageMobile: {
        margin: '0 auto',
    },
    productImageWrapper: {
        flex: '1 1 auto',
        order: '2',
        maxWidth: '600px',
        width: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            order: '1',
        },
        [theme?.breakpoints?.down('1024')]: {
            maxWidth: '100%',
            '& div': {
                marginBottom: '0.625rem',
            },
            '& button': {
                margin: '0px',
            },
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
        background: 'linear-gradient(270deg, #E7EDF1, #F2F8FC, #E7EDF1)',
        position: 'relative',
        aspectRatio: '0.89/0.97',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
        '&>div': {
            width: '100%',
            height: '100%',
            '&>img': {
                height: '100%',
            },
        },
        '@media(hover: none)': {
            '& div[style*="opacity: 1"]:before': {
                display: 'block',
                position: 'absolute',
                content: '""',
                background: 'url("https://images.contentstack.io/v3/assets/blt95e0138311135214/bltd4026f47a9492630/630fcc337cb46356cd3a8cf2/close.png")',
                backgroundSize: 'cover',
                height: '30px',
                width: '30px',
                zIndex: '100',
                top: '5px',
                right: '5px',
            },
        },
    },
    vertebrae3dContainer: {
        display: 'none',
        zIndex: 1,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    },
    vertebrae3dBtnContainer: {
        zIndex: 9,
        position: 'absolute',
        right: '-12px',
        bottom: '10px',
    },
    snipe: {
        position: 'absolute',
        top: '0px',
        right: '0',
        left: '0',
        width: '100%',
    },
    productImageWrapperClub: {
        display: 'inline-block',
        margin: '0',
        minWidth: '200px',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: '20px',
        },
        [theme?.breakpoints?.down('sm')]: {
            marginLeft: 0,
            maxWidth: '100%',
        },
    },
    monthSnipe: {
        overflow: 'auto',
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        padding: 5,
        backgroundColor: 'rgba(47,47,47, .9)',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
    },
    upsellSelected: {
        '& span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    upsellImageBox: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme.breakpoints.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'inline-block',
            maxWidth: '100%',
        },
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
        '&:last-child': {
            margin: 0,
            [theme.breakpoints.down('md')]: {
                margin: '20px 0 0 0',
            },
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        '& .slick-list': {
            display: 'none',
        },
        [theme.breakpoints.down('md')]: {
            width: '92%',
            margin: '0 auto',
        },
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            display: 'block',
            margin: '0 auto',
            '& .slick-slide': {
                float: 'left',
                whiteSpace: 'nowrap',
            },
            '& .slick-list': {
                display: 'block',
            },
        },
    },
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
    },
    videoAltButton: {
        '& img': {
            aspectRatio: '1/1.1',
        },
    },
    productImageWrapperInner: {
        position: 'relative',
    },
    videoClass: {
        width: '100%',
        minHeight: '597px',
        objectFit: 'cover',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            minHeight: 'auto',
        },
    },
    carouselContainer: {
        position: 'relative',
        width: '100%',
        maxHeight: '120px',
        '& .slick-list': {
            overflow: 'hidden',
            margin: '0px',
        },
        '& $altImageButton': {
            maxWidth: 'unset',
            width: '100px',
            padding: '0',
            backgroundColor: theme.palette.cms?.white || '#ffffff',
            margin: '0 10px 5px',
            [theme?.breakpoints?.down('md')]: {
                padding: '0px 10px 0px 0px',
                margin: 0,
            },
        },
        '& $altImageContainer': {
            [theme?.breakpoints?.down('md')]: {
                margin: '0px',
            },
        },
        '& $altImage': {
            width: '100%',
        },
        '& .slick-slide': {
            display: 'inline-block',
        },
        '& .slick-prev, & .slick-next': {
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            top: 0,
            bottom: 0,
            width: '30px',
            height: '110px',
            position: 'absolute',
            background: 'rgb(245 245 245 / 81%)',
            zIndex: 9999,
            '& svg': {
                height: 'inherit',
            },
        },
        '& .slick-prev': {
            left: 0,
        },
        '& .slick-next': {
            right: 0,
        },
        [theme?.breakpoints?.down('md')]: {
            width: 'auto',
        },
        '@media only screen and (max-width: 1280px) and (min-width: 600px)': {
            width: '100%',
        },
    },
    mainSliderContainer: {
        marginTop: '8px',
    },
    altImageName: {
        fontSize: '12px',
        margin: '-5px 0 10px 0',
        display: 'block',
    },
    pmallAltImageContainer: {
        textAlign: 'center',
        '@media screen and (max-width: 850px) and (min-width:601px)': {
            width: '74px',
        },
    },
    sliderOuterContainer: {
        width: '100%',
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme.breakpoints.down('md')]: {
            order: '2',
            maxWidth: '100%',
        },
    },
    sliderContainer: {
        position: 'relative',
        maxWidth: '1400px',
        margin: 'auto',
        '& .slick-list': {
            overflow: 'hidden',
            width: '90%',
            margin: '0 auto',
            [theme.breakpoints.up(1280)]: {
                height: '560px',
            },
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
        '& .slick-current': {
            paddingRight: 0,
        },
        '& .slick-prev, & .slick-next': {
            transform: 'rotate(90deg)',
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            width: 30,
            height: 25,
            position: 'absolute',
        },
        '& .slick-prev': {
            top: '-20px',
            left: '35%',
            opacity: '0.9',
            zIndex: '1',
        },
        '& .slick-next': {
            bottom: '-20px',
            right: '32%',
            opacity: '0.9',
        },
        '@media only screen and (max-width: 1280px) and (min-width: 600px)': {
            width: '100%',
        },
    },
    sliderAltImageContainer: {
        display: 'inline-block',
        flexWrap: 'wrap',
        margin: '0px',
        padding: '20px 10px 20px 0px',
        maxWidth: '110px',
        minWidth: '110px',
        '& $altImage': {
            width: '100%',
            height: '102px',
            '@media screen and (max-width: 850px) and (min-width:601px)': {
                height: 'auto',
            },
        },
        '& $videoAltButton': {
            '& img': {
                aspectRatio: '1/1.1',
            },
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
            display: 'flex',
            columnGap: '10px',
        },
    },
    closeButton: {
        top: '10px',
        position: 'absolute',
        zIndex: '999',
        right: '10px',
        padding: '0px',
        background: 'rgba(255, 255, 255, 0.8)',
        width: '30px',
        height: '30px',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.8)',
        },
        '& svg': {
            width: '12px',
            height: '12px',
            fill: '#2F2F2F',
        },
        '& .MuiTouchRipple-child': {
            background: 'transparent',
        },
    },
    responsiveWrapper: {
        position: 'relative',
    },
    zoomCopyDesktop: {
        display: 'none',
        '@media (hover: hover)': {
            [theme.breakpoints.up(1280)]: {
                display: 'block',
                fontSize: '14px',
                lineHeight: '18px',
                margin: '10px 0px 0px',
            },
        },
    },
    upsellWrapper: {
        display: 'inline-block',
        flexWrap: 'wrap',
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    magnifierContainer: {
        position: 'relative',
    },
    rootContainer: {
        '& $productImageWrapper': {
            maxWidth: '637px',
        },
    },
});
class GraphqlProductImageUI extends Component {
    constructor(props) {
        super(props);
        const {
            data: {
                name,
                image,
            },
            selectedSku,
            pmallSummaryInfo,
            selectedSkuBasedAltImages,
        } = this.props;

        const imageName = selectedSku?.image?.name || '';
        const imagePath = selectedSku?.image?.path || '';

        let defaultImagePath = this.buildImgPath(imagePath, imageName);
        const productBaseAltImages = image?.additionalImages ? [...image?.additionalImages] : [];
        const skuBasedAltImages = selectedSku?.image?.additionalImages ? [...selectedSku?.image?.additionalImages] : [];
        const altImagesData = selectedSkuBasedAltImages ? [...productBaseAltImages, ...skuBasedAltImages] : productBaseAltImages;

        /**
         * This component is removed from the page on window resize which causes us to lose state.
         * When it returns, it should detect if there is a pmall preview avaialble. If
         * it is, initialize the component with it included in the altImages array
         * and set the default image to it.
         */

        if (pmallSummaryInfo?.customizations?.refnum) {
            defaultImagePath = this.buildImgPath(null, pmallSummaryInfo?.customizations?.imageURL);
            if (!altImagesData.includes(pmallSummaryInfo.customizations.imageURL)) {
                altImagesData.push(pmallSummaryInfo?.customizations?.imageURL);
            }
        }

        this.state = {
            path: imagePath,
            mainImage: {
                path: imageName,
                fullPath: defaultImagePath,
                imgName: name,
            },
            heroImage: defaultImagePath,
            altImages: altImagesData,
            modalOpen: false,
            selectedComponentMonth: 0,
            videoUrl: '',
            isVideo: false,
        };

        this.cdnLink = imagePath || 'https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/catalog/';
    }

    componentDidUpdate(prevProps) {
        const {
            selectedSku, pmallSummaryInfo, selectedSkuBasedAltImages, data,
        } = this.props;
        const { altImages } = this.state;

        /**
         * This block runs when the user finishes the pmall iFrame workflow.
         * We need to inject pmall data into the alt images that came from the product data.
         *
         * A problem in the edit pmall workflow is that the url never changes. Because of that
         * the hero image, if already selected, never gets updated. We need to run this
         * block every time pmall finishes. Since it runs every time, we dont want to pile up
         * previews. Be sure to only ever add 1.
         */
        if (prevProps.pmallSummaryInfo !== pmallSummaryInfo) {
            const newAltImages = [...altImages];

            if (!pmallSummaryInfo?.customizations?.imageURL) {
                const filterDefaultImgs = newAltImages.filter((altImg) => altImg && !altImg.includes(sdkURL));
                this.setState({
                    altImages: filterDefaultImgs,
                }, this.setProductImage(selectedSku.image?.name));
            } else {
                if (!newAltImages.includes(pmallSummaryInfo?.customizations?.imageURL)) {
                    newAltImages.push(pmallSummaryInfo?.customizations?.imageURL);
                }
                this.setState({
                    altImages: newAltImages,
                },
                // once pmall is part of the alt images, make it the hero as well
                this.setProductImage(pmallSummaryInfo?.customizations?.imageURL));

                return;
            }
        }

        if (prevProps.selectedSku !== selectedSku && selectedSku?.image) {
            const imageName = selectedSku.image?.name || '';
            const productBaseAltImages = data?.image?.additionalImages ? [...data?.image?.additionalImages] : [];
            const skuBasedAltImages = selectedSku?.image?.additionalImages ? [...selectedSku?.image.additionalImages] : [];
            const altImagesData = selectedSkuBasedAltImages ? [...productBaseAltImages, ...skuBasedAltImages] : productBaseAltImages;
            const pmallImage = pmallSummaryInfo?.customizations?.imageURL;
            this.setProductImage(imageName);
            if (selectedSkuBasedAltImages) {
                if (pmallImage && !altImagesData.includes(pmallImage)) {
                    altImagesData.push(pmallImage);
                }
                this.setState({ altImages: altImagesData });
            }
        }
    }

    buildImgPath = (path, name, isAlt) => {
        const { pmallSummaryInfo } = this.props;
        const alt = isAlt || false;
        // eslint-disable-next-line no-nested-ternary
        const extension = (name || '').includes('_gif') ? '.gif' : alt ? 'c.jpg' : 'x.jpg';
        if (name === pmallSummaryInfo?.customizations?.imageURL) {
            let url = `https:${pmallSummaryInfo?.customizations?.imageURL}`;
            /**
             * To prevent caching, add in a count parameter to the query. The imageURL
             * string recieved from the iFrame already contains a query.
             */
            url += `&cacheBust=${pmallSummaryInfo?.countCacheBust || 0}`;
            return url;
        }

        return `${path + name + extension}`;
    };

    // If selected SKU image is 404 render parent image
    onImageError=(e) => {
        const { data, presentation_family } = this.props;
        if (data?.image?.path && presentation_family === 'food') {
            const { image } = data;
            e.target.src = this.buildImgPath(image.path, image.name);
        }
        return null;
    }

    getSlides = (items, isSlider = false) => {
        const slides = [];
        const { classes, isClubPDPV2 } = this.props;
        const { selectedComponentMonth } = this.state;
        (items || []).forEach((imgName, index) => {
            slides.push(
                (
                    <div
                        key={`btnImg-${imgName.month}`}
                        className={`${isSlider ? classes.upsellWrapper : classes.upsellImageBox} ${(items[selectedComponentMonth]?.month === imgName.month) ? classes.upsellSelected : ''}`}
                    >
                        <button
                            data-testid={`component-${index}`}
                            onClick={() => {
                                if (!isClubPDPV2) {
                                    this.setState({ modalOpen: true, selectedComponentMonth: index });
                                } else {
                                    this.setProductImage(imgName.image?.name);
                                }
                            }}
                            type="button"
                            className={classes.altImageButton}
                        >
                            <ResponsiveImage
                                path={`${this.cdnLink}${imgName.image?.name}x.jpg?width=110&height=124&auto=webp`}
                                alt={ReactHTMLParser(imgName.name)}
                                className={classes.altImage}
                            />
                            {!isClubPDPV2 && <span className={classes.monthSnipe}>{imgName.month?.substr(0, 3)}</span>}
                        </button>
                    </div>
                ),
            );
        });
        return slides;
    }

    handleState = (obj) => {
        this.setState(obj);
    }

    /**
     * @description onClick handler for altImages to re-render hero image.
     * @note also used on componentDidUpdate.
     * @param {string} file
     * @param {string} contentType
     */
    setProductImage = (file, contentType = '') => {
        const { selectedSku, pmallSummaryInfo } = this.props;
        const { path } = this.state;
        let imageName = selectedSku?.image?.name || '';
        let imagePath = selectedSku?.image?.path || '';
        const defaultImagePath = imagePath && imageName ? this.buildImgPath(imagePath, imageName) : '';

        // intercept these variable and fine tune for pmall
        if (pmallSummaryInfo?.customizations?.imageURL) {
            imageName = pmallSummaryInfo?.customizations?.imageURL;
            imagePath = this.buildImgPath(null, imageName);
        }

        if (contentType) {
            this.setState({
                heroImage: this.buildImgPath(path, file),
                mainImage: {
                    path: imageName,
                    fullPath: defaultImagePath,
                    imgName: selectedSku.name,
                },
                isVideo: true,
                videoUrl: file,
            });
        } else {
            this.setState({
                heroImage: this.buildImgPath(path, file),
                mainImage: {
                    path: imageName,
                    fullPath: defaultImagePath,
                    imgName: selectedSku.name,
                },
                isVideo: false,
                videoUrl: '',
            });
        }
    };

    trackProductImageClick = () => {
        this.props.emitCustomTrackingEvent({
            eventType: 'custom',
            eventSubType: 'feature-tracking',
            action: 'Click',
            category: 'Product Image',
            label: 'Click on Image',
        });
    };

    renderZoom = () => {
        const { location, featureFlags } = this.props;
        const isPdpImageZoomEnabled = featureFlags['is-pdp-product-zoom-enabled'] || featureFlags['is-pdp-product-image-zoom-enabled'];
        const isPlaImageZoomEnabled = featureFlags['is-pla-product-zoom-enabled'];
        const isPla = isProductListingAd(location.search);
        if (isPla && isPlaImageZoomEnabled) return true;
        if (!isPla && isPdpImageZoomEnabled) return true;
        return false;
    }

    navigate = (type = 'next') => {
        const { selectedComponentMonth } = this.state;
        const { clubComponents } = this.props;
        const slidesLength = clubComponents?.length;
        if (type === 'next') {
            if ((slidesLength - 1) === selectedComponentMonth) {
                this.setState({ selectedComponentMonth: 0 });
            } else {
                this.setState({ selectedComponentMonth: (selectedComponentMonth + 1) });
            }
        } else if (type === 'prev') {
            if (selectedComponentMonth === 0) {
                this.setState({ selectedComponentMonth: (slidesLength - 1) });
            } else {
                this.setState({ selectedComponentMonth: (selectedComponentMonth - 1) });
            }
        }
    }

    getClubLengthDescription = () => {
        const { selectedSku } = this.props;
        const clubLength = selectedSku?.clubLength || 0;
        if (selectedSku?.date && selectedSku?.endDate) {
            return (
                <>
                    {`${clubLength} Months - ${selectedSku.date.month} ${selectedSku.date.year} - ${selectedSku.endDate.month} ${selectedSku.endDate.year}`}
                </>
            );
        }
        return null;
    }

    render() {
        const {
            featureFlags,
            classes,
            data,
            selectedSku,
            smartGiftLetThemKnowSection,
            isSmartGiftEnabled,
            brand,
            isClubProduct,
            clubComponents,
            renderSnipe,
            renderHeroImageFlag,
            altImagesContainerStyle,
            productBaseContent,
            presentation_family,
            setShippingModalOpen,
            productUrl,
            partNumber,
            isClubPDPV2,
            location,
            whichFoodPlaDesign,
            isPdpRedesignEnabled,
        } = this.props;
        const {
            mainImage,
            altImages,
            path,
            heroImage,
            isVideo,
            videoUrl,
        } = this.state;

        const videoBlock = productBaseContent?.entries?.[0]?.product_page_video || {};
        const previewImage = videoBlock?.static_image_preview?.url || '';
        const contentType = videoBlock?.video?.content_type || '';

        let isProductHasSmartGiftEnabled = true; // for flowers brand handle by LD.
        if (presentation_family === 'food') {
            isProductHasSmartGiftEnabled = data?.isSmartgiftEnabled; // food brands will use product based smart gift
        }
        const decodedString = decodeURI(location.search).replace('?', '');
        const queryParams =  qs.parse(decodedString);
        const isDisplayChannel = queryParams?.utm_medium === 'display' && featureFlags['is-pla-pdp-display-channel-enabled'];
        const isPla = isProductListingAd(location.search);
        const threeColumnPLA = (isPla || isDisplayChannel) && whichFoodPlaDesign === 'three_column';
        // Use heroImage state to update pdp images when skus are changed
        // To use only the main image and not update by sku, use presentation logic
        // to grab image source from data.image
        const personalizationFlag = featureFlags['is-personalization-enabled'] ?? false;

        // Added logic to render the snipe image on the main image only
        const altImagePath = heroImage?.split('/');
        const mainImagePath = mainImage?.fullPath?.split('/');

        // Check if the last segment of the alt image path matches the last segment of the main image path
        const showSnipeImage = altImagePath?.[altImagePath?.length - 1] === mainImagePath?.[mainImagePath?.length - 1];

        const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
        const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';
        const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
        const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;
        const setLayout = () => {
            const imageSource = heroImage;
            return (
                isVideo ?  (
                    <VideoComponent
                        classes={classes}
                        videoUrl={videoUrl}
                        previewImage={previewImage}
                        videoClass={classes.videoClass}
                        contentType={contentType}
                        videoBlock={videoBlock}
                        productBaseCode={data?.baseCode}
                    />
                )
                    : (
                        <>
                            {
                                this.renderZoom() ? (
                                    <ProductImageZoomingUI
                                        imagePath={heroImage}
                                        data={data}
                                        classes={classes}
                                        isRenderSnipe={renderSnipe && showSnipeImage}
                                        personalizationFlag={personalizationFlag}
                                    />
                                )
                                    : (
                                        <div
                                            id="responsive-wrapper"
                                        >
                                            <ResponsiveImage
                                                className={classes.productImage}
                                                path={imageSource}
                                                alt={ReactHTMLParser(data?.name)}
                                                params={{
                                                    desktop: 'width=545&height=597&auto=webp',
                                                    tablet: 'width=406&height=445auto=webp',
                                                }}
                                                breakpoints={{
                                                    desktop: '1024px',
                                                    tablet: '640px',
                                                }}
                                            />
                                            {renderSnipe && showSnipeImage && shouldRenderSnipe(data?.image?.snipe, personalizationFlag) && isSnipeImageActive(data?.image, 'pdp')  ? ( // if snipe data exist display snipe img
                                                <LazyLoad>
                                                    <Fade in timeout={700}>
                                                        <SnipeRender
                                                            altText={data?.image?.altText}
                                                            styleProp={classes.snipe}
                                                            src={`${data?.image?.snipeImagePath}${data?.image?.snipe}_z.gif?auto=webp`}
                                                            fallbackSrc={`${snipePath(data.image.path)}${data?.image?.snipe}_z.gif?auto=webp`}
                                                        />
                                                    </Fade>
                                                </LazyLoad>
                                            ) : null}
                                            {showSnipeImage && <SnipeRenderQuery  partNumber={partNumber || data?.partNumber || data?.id}  productType="product" />}
                                            <FavoritesUI partNumber={partNumber || data?.partNumber || data?.id} />
                                        </div>
                                    )
                            }
                        </>
                    )
            );
        };
        const pmallAltImageRender = () => (
            selectedSku?.image?.productThumbnails?.map((item) => (
                <div className={classes.pmallAltImageContainer} key={item?.name}>
                    <button
                        type="button"
                        className={classes.altImageButton}
                        onClick={() => {
                            this.trackProductImageClick();
                            this.setProductImage(item?.name);
                        }}
                    >
                        <ResponsiveImage path={this.buildImgPath(item?.path, item?.name)} alt={ReactHTMLParser(item?.name)} className={classes.altImage} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                    </button>
                    <span className={classes.altImageName}>{item?.description}</span>
                </div>
            ))
        );

        const altImageRender = () => {
            const { trackEvent } = this.props;
            const trackEventObj = {
                eventCategory: 'product image',
                eventAction: 'click',
            };
            return (
                altImages.map((imgName, index) => (
                    <button
                        key={`btnImg${imgName}`}
                        type="button"
                        className={classes.altImageButton}
                        onClick={() => {
                            this.trackProductImageClick();
                            this.setProductImage(imgName);
                            trackEvent({
                                ...trackEventObj,
                                eventLabel: `${data?.baseCode} | ${this.buildImgPath(path, imgName)}| ${videoBlock?.enabled ? index + 3 : index + 2}`,

                                ga_event_name: 'image_carousel_interaction',
                                image_url: this.buildImgPath(path, imgName, true),
                                image_alt: mainImage?.altImage,
                                image_index: index + 1,
                                image_count: altImages.length,
                            });
                        }}
                    >
                        <ResponsiveImage
                            path={this.buildImgPath(path, imgName, true)}
                            alt={mainImage?.imgName}
                            className={classes.altImage}
                            params={{ desktop: 'width=100&height=110', tablet: 'width=100&height=110', mobile: 'width=100&height=110' }}
                        />
                    </button>
                ))
            );
        };

        const renderAlternateImages = () => {
            const { trackEvent } = this.props;
            const trackEventObj = {
                eventCategory: 'product image',
                eventAction: 'click',
            };

            if (data?.brandId === '1030' || data?.brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType) {
                return (
                    <div className={`${threeColumnPLA ? classes.plaAltImages : ''} ${classes.altImageContainer} ${classes.sliderAltImageContainer} ${altImagesContainerStyle}`}>
                        {selectedSku?.image?.productThumbnails?.length > 3 ? (
                            <div className={classes.sliderOuterContainer}>
                                <Slider
                                    speed={500}
                                    slidesToShow={4}
                                    slidesToScroll={1}
                                    nextArrow={<ChevronRightIcon />}
                                    prevArrow={<ChevronLeftIcon />}
                                    vertical
                                    verticalSwiping
                                    className={`carousel-container ${classes.sliderContainer}`}
                                    responsive={[
                                        {
                                            breakpoint: 1400,
                                            settings: {
                                                slidesToShow: 3,
                                                slidesToScroll: 1,
                                            },
                                        },
                                        {
                                            breakpoint: 1280,
                                            settings: {
                                                slidesToShow: 3,
                                                slidesToScroll: 3,
                                                variableWidth: true,
                                                vertical: false,
                                                verticalSwiping: false,
                                                className: classes.carouselContainer,
                                            },
                                        },
                                    ]}
                                >

                                    {pmallAltImageRender()}
                                    {altImageRender()}
                                </Slider>
                            </div>
                        )
                            : (
                                <>
                                    {pmallAltImageRender()}
                                    {altImageRender()}
                                </>
                            )}

                    </div>
                );
            }
            return (
                <div className={`${threeColumnPLA ? classes.plaAltImages : ''} ${classes.altImageContainer} ${altImagesContainerStyle}`}>
                    <button
                        type="button"
                        className={classes.altImageButton}
                        onClick={() => {
                            this.trackProductImageClick();
                            this.setProductImage(selectedSku?.image?.name);
                            trackEvent({
                                ...trackEventObj,
                                eventLabel: `${data?.baseCode} | ${this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name)}| 1`,
                            });
                        }}
                    >
                        <ResponsiveImage path={this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name)} alt={ReactHTMLParser(mainImage?.imgName)} className={classes.altImage} params={{ desktop: 'width=100&height=110', tablet: 'width=100&height=110', mobile: 'width=100&height=110' }} />
                    </button>
                    {videoBlock?.enabled && (
                        <button
                            type="button"
                            className={`${classes.altImageButton} ${classes.videoAltButton}`}
                            onClick={() => {
                                this.trackProductImageClick();
                                this.setProductImage(videoBlock?.video?.url, videoBlock?.video?.content_type);
                                trackEvent({
                                    ...trackEventObj,
                                    eventLabel: `${data?.baseCode} | ${previewImage}| 2`,
                                });
                            }}
                        >
                            <ResponsiveImage path={previewImage} alt="Video" className={classes.altImage} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                        </button>
                    )}
                    {altImages.map((imgName, index) => (
                        <button
                            key={`btnImg${imgName}`}
                            type="button"
                            className={classes.altImageButton}
                            onClick={() => {
                                this.trackProductImageClick();
                                this.setProductImage(imgName);
                                trackEvent({
                                    ...trackEventObj,
                                    eventLabel: `${data?.baseCode} | ${this.buildImgPath(path, imgName)}| ${videoBlock?.enabled ? index + 3 : index + 2}`,
                                    ga_event_name: 'image_carousel_interaction',
                                    image_url: this.buildImgPath(path, imgName, true),
                                    image_alt: mainImage?.altImage,
                                    image_index: index + 2,
                                    image_count: altImages.length,
                                });
                            }}
                        >
                            <ResponsiveImage
                                path={this.buildImgPath(path, imgName, true)}
                                alt={mainImage?.imgName}
                                className={classes.altImage}
                                params={{ desktop: 'width=100&height=110', tablet: 'width=100&height=110', mobile: 'width=100&height=110' }}
                            />
                        </button>
                    ))}
                </div>
            );
        };

        if (!renderHeroImageFlag && isClubProduct) {
            const { modalOpen, selectedComponentMonth } = this.state;
            return (
                <div
                    data-testid="rendered-club-image"
                >
                    <GraphqlClubPDPImage
                        modalOpen={modalOpen}
                        handleState={this.handleState}
                        selectedComponentMonth={selectedComponentMonth}
                        cdnLink={this.cdnLink}
                        clubComponents={clubComponents}
                        product={data}
                        navigate={this.navigate}
                        getSlides={this.getSlides}
                        renderZoom={this.renderZoom}
                        shouldRenderSnipe={shouldRenderSnipe}
                        getClubLengthDescription={this.getClubLengthDescription}
                        selectedSku={selectedSku}
                        heroImage={heroImage}
                        personalizationFlag={personalizationFlag}
                        setShippingModalOpen={setShippingModalOpen}
                        productUrl={productUrl}
                        isClubPDPV2={isClubPDPV2}
                        productImage={this.setProductImage}
                    />
                </div>
            );
        }
        const isPmallProduct = featureFlags['is-pmall-pdp-template-enabled'] && (data?.brandId === '1030' || data?.brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType);

        return (
            <div className={`${classes.root} ${isPdpRedesignEnabled ? classes.rootContainer : ''}`}>
                <div className={classes.productImageWrapper}>
                    <div
                        className={classes.productImageWrapperInner}
                    >
                        {setLayout()}
                    </div>
                    <Media
                        query="(max-width: 1279px)"
                    >
                        {(matches) => (matches
                        && (
                            featureFlags['pdp-image-sticky'] && !isPmallProduct
                                ? (
                                    <CarouselAltImg
                                        classes={classes}
                                        buildImgPath={this.buildImgPath}
                                        setProductImage={this.setProductImage}
                                        selectedSku={selectedSku}
                                        videoBlock={videoBlock}
                                        data={data}
                                        previewImage={previewImage}
                                        mainImage={mainImage}
                                        altImages={altImages}
                                        path={path}
                                    />
                                ) : renderAlternateImages()
                        ))}
                    </Media>
                    {isSmartGiftEnabled && !isProductHasSmartGiftEnabled
                            && (
                                <SmartGiftContainer>
                                    <SmartGift
                                        giftData={smartGiftLetThemKnowSection}
                                        partNumber={data.partNumber}
                                        productName={data.name}
                                        brand={brand}
                                        sku={selectedSku?.id}
                                        price={selectedSku?.prices}
                                        image={heroImage}
                                        featureFlags={featureFlags}
                                    />
                                </SmartGiftContainer>
                            )}
                </div>
                <Media query="(max-width: 1279px)">
                    {(matches) => (!matches
                            && (altImages && !renderHeroImageFlag) && renderAlternateImages()
                    )}
                </Media>
            </div>
        );
    }
}

GraphqlProductImageUI.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
    featureFlags: object,
    location: object.isRequired,
    presentation_family: string.isRequired,
    selectedSku: object.isRequired,
    smartGiftLetThemKnowSection: shape({
        button_copy: string,
        button_color: string,
        copy: string,
    }),
    brand: shape({
        domain: string,
    }),
    isSmartGiftEnabled: bool,
    isClubProduct: bool,
    clubComponents: clubComponentType,
    renderSnipe: bool,
    renderHeroImageFlag: bool,
    altImagesContainerStyle: string,
    productBaseContent: shape({
        entries: arrayOf(shape({
            products_viewed_section: shape({
                background_color: string,
                copy: string,
                font_color: string,
            }),
        })),
    }),
    trackEvent: func.isRequired,
    emitCustomTrackingEvent: func.isRequired,
    pmallSummaryInfo: shape({
        customizations: shape({
            refnum: string,
            imageURL: string,
        }),
    }).isRequired,
    setShippingModalOpen: func,
    productUrl: string,
    partNumber: string,
    isClubPDPV2: bool,
    whichFoodPlaDesign: string,
    isPdpRedesignEnabled: bool,
    selectedSkuBasedAltImages: bool,
};

GraphqlProductImageUI.defaultProps = {
    isClubProduct: false,
    clubComponents: [],
    brand: {},
    smartGiftLetThemKnowSection: {},
    isSmartGiftEnabled: false,
    renderSnipe: true,
    renderHeroImageFlag: false,
    altImagesContainerStyle: '',
    productBaseContent: {},
    setShippingModalOpen: () => { },
    featureFlags: {},
    productUrl: '',
    partNumber: '',
    isClubPDPV2: false,
    whichFoodPlaDesign: '',
    isPdpRedesignEnabled: false,
    selectedSkuBasedAltImages: false,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    emitCustomTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

const mapStateToProps = (state) => ({
    pmallSummaryInfo: getPmallSummaryInfo(state),
    whichFoodPlaDesign: getFeatureFlag('which-food-pla-design')(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GraphqlProductImageUI));
